export const TENANT_BRANDING = {
  id: 'prover',
  name: 'Policlínica Oftalmológica ProVer',
  shortName: 'ProVer',
  tagline: 'Salud visual y oftalmología de excelencia',
  vertical: 'healthcare-ophthalmology',
  location: 'Asunción, Capital, Paraguay',
  phone: '',
  emergency: '',
  hours: {
    weekday: 'Lun-Vie 08:00-18:00',
    saturday: 'Sáb 08:00-12:00',
    emergency: ''
  },
  domains: [
    'prover.com.py',
    'www.prover.com.py'
  ]
};
